import {
  Box,
  FormControl,
  FormHelperText,
  Typography,
  MenuItem,
} from '@mui/material';
import { styled } from '@mui/material/styles';

export const ContainerBox = styled(Box)({
  marginBottom: 1,
});

export const LabelTypography = styled(Typography)({
  fontFamily: 'Outfit',
  fontWeight: '400',
  fontSize: '16px',
  color: 'var(--primary-navy)',
  marginBottom: 16,
});

export const StyledFormControl = styled(FormControl)({
  margin: 0,
});

export const StyledMenuItem = styled(MenuItem)<{
  fontSize?: string;
  fontWeight?: string;
}>(({ fontSize = '16px', fontWeight = '400' }) => ({
  fontFamily: 'Outfit',
  fontSize,
  fontWeight,
  '&.Mui-selected': {
    backgroundColor: 'var(--inactive-btn)',
    color: 'var(--primary-blue)',
  },
}));

export const StyledFormHelperText = styled(FormHelperText)({
  fontFamily: 'Outfit',
  fontWeight: '400',
  fontSize: '14px',
  color: 'var(--error)',
  display: 'flex',
  alignItems: 'center',
  marginLeft: 0,
  marginTop: 8,
});

export const ErrorIcon = styled(Box)({
  fontSize: '16px',
  color: 'var(--error)',
  marginRight: 6,
});

export const MenuPaperStyles = styled(Box)<{ borderColor?: string }>(
  ({ borderColor = 'var(--border)' }) => ({
    marginTop: 4,
    borderRadius: 8,
    border: `1px solid ${borderColor}`,
    backgroundColor: 'var(--text-bg)',
    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
    maxHeight: '230px',
    '&::-webkit-scrollbar': {
      width: '6px',
    },
    '&::-webkit-scrollbar-track': {
      backgroundColor: 'var(--bg-color)',
      borderRadius: '4px',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: 'var(--loader-color)',
      borderRadius: '4px',
    },
    '&::-webkit-scrollbar-thumb:hover': {
      backgroundColor: 'var(--primary-blue)',
      cursor: 'pointer',
    },
  })
);

export const getMenuPaperProps = (borderColor: string) => ({
  component: MenuPaperStyles,
  borderColor,
});
